<template lang="pug">
div(@click.stop="onFollow"
  :class="{'following': isFollowingAsset}"
  ).wrap-item-btn-follow-asset.px12.py6.rounded.cursor-pointer.f.fh
  span.fz14.bold {{label}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-btn-follow-asset {
  width: 160px;
  background: $active_color;
  border: solid 1px $primary_bg_color;
  span {
    color: $dark_primary_text_color
  }
  &.following {
    background: $primary_bg_color;
    border: solid 1px $active_color;
    span {
      color: $active_color;
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    asset: {
      type: Object,
      required: true
    },
    me: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    label () {
      return this.isFollowingAsset ? 'フォロー中' : 'アセットをフォロー'
    }
  },
  data () {
    return {
      isFollowingAsset: false,
      isSaving: false,
    }
  },
  async created () {
    this.isFollowingAsset = this.me.followingAssets.includes(this.asset.id)
  },
  methods: {
    async onFollow () {
      if (this.isSaving) return
      this.isSaving = true

      if (!this.me) {
        const redirectPath = encodeURIComponent(this.$route.path)
        this.$root.$emit('showNavigationMessage', {
          message: 'アセットをフォローするにはログインする必要があります',
          to: `/sign-in/${redirectPath}`,
          showOK: true
        })
        return
      }

      const followingRef = database.userFollowingAssetCollection(this.uid)
      
      if (this.isFollowingAsset) {
        this.isFollowingAsset = false
        await followingRef.delete(this.asset.id)
        await database.userCollection()
          .deleteFollowingAsset({ uid: this.uid, assetId: this.asset.id })
      } else {
        this.isFollowingAsset = true
        const followingObj = {
          assetId: this.asset.id,
          assetCreatedBy: this.asset.createdBy,
          createdBy: this.uid,
          createdAt: new Date()
        }
        await followingRef.set(this.asset.id, followingObj)
        await database.userCollection()
          .addFollowingAsset({ uid: this.uid, assetId: this.asset.id })
      }
      this.$root.$emit('updateFollowingAssets', this.asset.id)
      
      await this.sleep(400)
      this.isSaving = false
    },
  }
}
</script>
